export default (state = {}, action) => state;
